document.querySelector('.menu').addEventListener('click', function (event) {
    const menuLinkClicked = event.target.classList.contains('menu__link') || event.target.closest('.menu__link');

    if (!menuLinkClicked) {
        return;
    }

    const link = event.target.closest('.menu__link');

    if (link.getAttribute("href") == '#') {
        event.preventDefault();
    }

    const submenu = event.target.closest('.menu__item').querySelector('.menu');

    if (submenu) {
        event.preventDefault();
        submenu.classList.toggle('menu--opened');
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const menu = document.querySelector('.menu__link--actived')?.parentElement;

    if (menu == null) return

    openMenu(menu);
});

function openMenu(menu)
{
    menu.classList.toggle('menu--opened');
    if (!menu.parentElement.classList.contains('main-menu')) {
        openMenu(menu.parentElement);
    }
}
